
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Box,
  Drawer,
  useMediaQuery,
  IconButton,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { PiUsersThreeFill } from "react-icons/pi";
import { RxExit } from "react-icons/rx";
import logo from "../../Assets/logo.png";
import { MdDashboard } from "react-icons/md";
import { ImStack } from "react-icons/im";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { GoDotFill } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import { logout, logoutUser } from "../../ReduxStore/Slices/authSlice";
// import { logout } from '../../ReduxStore/Slices/authSlice';
import { MdOutlineDashboard } from "react-icons/md";
import "./Sidebar.css";
import { FaUserCog } from "react-icons/fa";
import { LuUserRoundCog } from "react-icons/lu";
import { RiListSettingsLine } from "react-icons/ri";
import { RiFileSettingsLine } from "react-icons/ri";
import { RiVipCrown2Line } from "react-icons/ri";
import { TbShoppingBagCheck } from "react-icons/tb";
import actions from "../../ReduxStore/actions";
import { IoSettings, IoSettingsOutline } from "react-icons/io5";

const Sidebar = ({ open, onClose, dynamicLogo }) => {
  const dispatch = useDispatch();

  // const { getPermissionsForAuthUser } = useSelector((state) => state?.getPermissionsForAuthUser);

  // const roleId = sessionStorage.getItem("userRoleId")
  // useEffect(() => {
  //   if (roleId) {
  //     console.log("itssssssssssss")
  //     const data1 = {
  //       data: {},
  //       method: "get",
  //       apiName: `getPermissionsForAuthUser/${roleId}`,
  //     };

  //     dispatch(actions.GETPERMISSIONSFORAUTHUSER(data1));
  //   }
  // }, [])
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedMenu, setExpandedMenu] = useState(null);

  const toggleMenu = (menuName) => {
    setExpandedMenu((prevState) => (prevState === menuName ? null : menuName));
  };

  // const { role, permissions } = useSelector((state) => state.auth); /// Get role and permissions from Redux state
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem("role");

    // dispatch(logout());
    navigate("/"); // Redirect to login after logout
    localStorage.setItem("authToken", null)
    
  };
  // const { permissions } = useSelector((state) => state.auth);
  // const permissions = JSON.parse(localStorage.getItem("permissions")) || {};
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const role = sessionStorage.getItem("role");

  console.log(role, "roleeeeee")

  const SidebarLink = ({ to, icon, label, end = false }) => (
    <NavLink
      to={to}
      end={end}
      style={({ isActive }) => ({
        display: "flex",
        alignItems: "center",
        padding: "10px",
        marginBottom: "10px",
        textDecoration: "none",
        color: isActive ? "black" : "white",
        backgroundColor: isActive ? "white" : "transparent",
        borderRadius: "4px",
      })}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {icon}
        <Typography variant="subtitle1">{label}</Typography>
      </Box>
    </NavLink>
  );

  const SidebarSubmenu = ({ menuName, items, icon, label }) => (
    <Box>
      <Box
        onClick={() => toggleMenu(menuName)}
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "10px",
          marginBottom: "10px",

          cursor: "pointer",
          color: expandedMenu === menuName ? "white" : "white",
          // color: "white",
          "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.1)" },
        }}
      >
        {icon}
        {/* {label} */}
        <Typography variant="subtitle1">{label}</Typography>

        <IconButton size="small" sx={{ marginLeft: "auto", color: "white" }}>
          {expandedMenu === menuName ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      {expandedMenu === menuName && (
        <Box sx={{ paddingLeft: 3 }}>
          {items.map(
            (item) =>
              // item.permission && (
              <SidebarLink
                key={item.to}
                to={item.to}
                icon={
                  <GoDotFill
                    // style={{ 
                    style={({ isActive }) => ({

                      color: isActive ? "white" : "red", fontSize: "20px"
                    })} />
                }
                label={item.label}
              />
            // )
          )}
        </Box>
      )}
    </Box>
  );

  const renderSidebarContent = () => (
    <>

      <SidebarLink
        to="/admin"
        icon={<MdOutlineDashboard className="sidebar-icon" />}
        label="Dashboard"
        end
      />


      <SidebarSubmenu
        menuName="master"
        icon={<RiListSettingsLine className="sidebar-icon" />}
        label="Master"
        items={[

          {
            to: "/admin/department",
            label: "Department",
          },
          {
            to: "/admin/subdepartment",
            label: "Sub Department",
          },
          {
            to: "/admin/designation",
            label: "Designation",
          },
          {
            to: "/admin/krakpi",
            label: "KRA & KPI",
          },
          {
            to: "/admin/yearofdappraisal",
            label: "Year of Appraisal",
          },

        ]}
      />

      <SidebarSubmenu
        menuName="usermanagement"
        icon={<LuUserRoundCog className="sidebar-icon" />}
        label="User Management"
        items={[
          {
            to: "/admin/addemployee",
            label: "Add Employee",
          },
          // {
          //   to: "/admin/employeedetails",
          //   label: "Employee Details",
          // },
          {
            to: '/admin/employeepdfupload',
            label: 'Employee PDF Upload',
          },


        ]}
      />

      <SidebarSubmenu
        menuName="kpimanagement"
        icon={<RiFileSettingsLine className="sidebar-icon" />}
        label="KRA & KPI Management"
        items={[
          {
            to: "/admin/rolewisekrakpi",
            label: "Role Wise KRA & KPI",
            // permission: permissions?.ContentManagement?.Home?.view,
          },

        ]}
      />


      <SidebarSubmenu
        menuName="report"
        icon={<RiVipCrown2Line className="sidebar-icon" />}
        label="Reports"
        items={[
          {
            to: "/admin/overviewreports",
            label: "Overview Reports",
          },
          {
            to: "/admin/bellcurvereports",
            label: "Bell Curve Reports",
          },
          {
            to: "/admin/pmsscoreenable",
            label: "PMS Score Enable",
          },

        ]}
      />


      {/* <SidebarSubmenu
        menuName="settings"
        icon={<IoSettingsOutline className="sidebar-icon" />}
        label="Settings"
        items={[
          // {
          //   to: "/admin/sitesettings",
          //   label: "Theme Settings",
          // },
          {
            to: "/admin/mailsettings",
            label: "Mail Settings",
          },
          // {
          //   to: "/admin/userssync",
          //   label: "Users Sync",
          // },
          

        ]}
      /> */}


      {/* <SidebarLink
        to="/admin/sitesettings"
        icon={<IoSettingsOutline className="sidebar-icon" />}
        label="settings"
        end
      />
 */}



      {/* Add more menus as needed with permission checks */}
    </>
  );

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      variant={isMobile ? "temporary" : "permanent"}
      sx={{
        width: 270,

        "& .MuiDrawer-paper": {
          position: { xs: "fixed", md: "static" }, // Fixed for small screens, static for larger screens

          width: 270,
          boxSizing: "border-box",
          background: "#2a3042",
          borderRadius: "10px",
        },
      }}
    >
      <NavLink to="/admin" style={{ textDecoration: "none" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          <img
            src={dynamicLogo}
            alt="logo"
            style={{ height: "47px", width: "180px" }}
          />
        </Box>
      </NavLink>

      <Box
        sx={{ display: "flex", flexDirection: "column", flexGrow: 1, px: 1 }}
      >
        {renderSidebarContent()}
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
          color: "white",
          cursor: "pointer",
          fontSize: "16px",
          "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.1)" },
        }}
        onClick={handleLogout}
      >
        <RxExit style={{ marginRight: "10px" }} />
        Logout
      </Box>
    </Drawer>
  );
};

export default Sidebar;

